import { EditorState } from 'prosemirror-state'
import { MentionType, ProseInputMention } from './Types'

export const extractMentions = (state: EditorState): ProseInputMention[] => {
  const mentions: ProseInputMention[] = []
  state.doc.descendants((node) => {
    if (node.type !== state.schema.nodes.smart_link) {
      return
    }
    if (node.attrs.type === MentionType.User) {
      mentions.push({ id: parseInt(node.attrs.userId, 10), title: node.attrs.title, type: MentionType.User })
      return
    }
    if (node.attrs.type === MentionType.Article) {
      mentions.push({ id: node.attrs.key, title: node.attrs.title, type: MentionType.Article })
      return
    }
  })
  return mentions
}

export const extractPills = (state: EditorState): string[] => {
  const pills: string[] = []
  state.doc.descendants((node) => {
    if (node.type !== state.schema.nodes.pill) {
      return
    }
    pills.push(node.attrs.text)
  })
  return pills
}
